// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.payments-table table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;
}
.payments-table table caption {
  caption-side: top;
  text-align: center;
}
.payments-table table thead > tr > th {
  border-radius: 5px 5px 0 0;
  background-color: #C0DEF0;
  border-color: #A7A9AC;
  border-style: solid;
  border-width: 1px;
  color: #19608f;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 5px;
  text-align: center;
}
.payments-table table thead > tr > th.icon-header {
  font-size: 1.65rem;
}
.payments-table table thead > tr > th.subheader {
  border-radius: revert;
  border: none;
  font-size: 0.75rem;
}
.payments-table table thead > tr > th.left {
  border-left: 1px solid #A7A9AC;
}
.payments-table table thead > tr > th.right {
  border-right: 1px solid #A7A9AC;
}
.payments-table table tbody > tr {
  border-left: 1px solid #A7A9AC;
  border-right: 1px solid #A7A9AC;
}
.payments-table table tbody > tr.stripe {
  background-color: #EDf0F1;
}
.payments-table table tbody > tr.out-of-district {
  background-color: #FDF9D0;
}
.payments-table table tbody > tr.hidden-row {
  display: none;
}
.payments-table table tbody > tr > td {
  border-right: 1px solid #D1D3D4;
  border-bottom: 1px solid #D1D3D4;
  font-size: 0.78rem;
  padding: 3px;
}
.payments-table table tbody > tr > td > button {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.payments-table table tbody > tr > td > button span {
  font-size: 0.9rem;
  font-weight: 500;
}
.payments-table table tbody > tr > td.email {
  max-width: 10%;
  width: 180px;
  word-wrap: anywhere;
}
.payments-table table tbody > tr > td.icons {
  align-items: right;
  background-color: white;
  border: none;
  border-bottom: 1px solid #D1D3D4;
  border-left: 1px solid #D1D3D4;
}
.payments-table table tbody > tr > td.icons-with-note {
  align-items: right;
  background-color: white;
  border: none;
  border-bottom: none;
  border-left: 1px solid #D1D3D4;
}
.payments-table table tbody > tr > td.oe-out {
  background-color: white;
}
.payments-table table td.center {
  text-align: center;
}
.payments-table table tbody > tr > td > div > textarea {
  border-radius: 5px;
  width: 100%;
}
.payments-table table tbody > tr > td > div > button {
  margin-top: 5px;
}
.payments-table table tbody > tr > td.first {
  border-left: 1px solid #A7A9AC;
}
.payments-table table tbody > tr > td.last {
  border-right: 1px solid #A7A9AC;
}
.payments-table table tbody > tr > td.notes {
  background: #C0DEF0;
  font-size: 0.9rem;
  padding: 10px;
}
.payments-table table tbody > tr > td.icon-last {
  border: none;
  border-left: 1px solid #D1D3D4;
  border-bottom: 2px solid #A7A9AC;
}
.payments-table table tbody > tr > td > div.flexed-td {
  align-items: center;
  display: flex;
  font-size: 0.7rem;
  justify-content: flex-start;
}
.payments-table table tfoot > tr {
  background-color: white;
}
.payments-table table tfoot > tr > td {
  border-top: 1px solid #A7A9AC;
  padding-top: 10px;
}
.payments-table table tfoot > tr > td.icons {
  border-top: 1px solid #A7A9AC;
  padding-top: 10px;
}
.payments-table table tfoot > tr > td > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}
.payments-table table tfoot > tr > td > div > .showing-records {
  font-size: 0.8rem;
  font-style: italic;
  margin-top: 5px;
  width: 33%;
}
.payments-table table .small {
  font-size: 0.7rem;
  font-weight: 500;
  margin-left: 5px;
  margin-right: 5px;
}
.payments-table table .fixed-btn {
  display: block;
  margin: 2px 0 2px 0;
  min-width: 120px;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/PaymentsTable.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAAI;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;AAGR;AAFQ;EACI,iBAAA;EACA,kBAAA;AAIZ;AAFQ;ECTJ,0BDU2C;EACnC,yBDiBA;EChBA,qBDWJ;ECVI,mBAAA;EACA,iBAAA;EACA,cDXF;ECYE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAIZ;AAFQ;EACI,kBAAA;AAIZ;AAFQ;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;AAIZ;AAFQ;EACI,8BAAA;AAIZ;AAFQ;EACI,+BAAA;AAIZ;AAFQ;EACI,8BAAA;EACA,+BAAA;AAIZ;AAFQ;EACI,yBDnBJ;ACuBR;AAFQ;EACI,yBDhCA;ACoCZ;AAFQ;EACI,aAAA;AAIZ;AAFQ;EACI,+BAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AAIZ;AAFQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAIZ;AAHY;EACI,iBAAA;EACA,gBAAA;AAKhB;AAFQ;EACI,cAAA;EACA,YAAA;EACA,mBAAA;AAIZ;AAFQ;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;EACA,8BAAA;AAIZ;AAFQ;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;AAIZ;AAFQ;EACI,uBAAA;AAIZ;AAFQ;EACI,kBAAA;AAIZ;AAFQ;ECxFJ,kBDyF2C;EACnC,WAAA;AAIZ;AAFQ;EACI,eAAA;AAIZ;AAFQ;EACI,8BAAA;AAIZ;AAFQ;EACI,+BAAA;AAIZ;AAFQ;EACI,mBD1EA;EC2EA,iBAAA;EACA,aAAA;AAIZ;AAFQ;EACI,YAAA;EACA,8BAAA;EACA,gCAAA;AAIZ;AAFQ;EACI,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;AAIZ;AAFQ;EACI,uBAAA;AAIZ;AAFQ;EACI,6BAAA;EACA,iBAAA;AAIZ;AAFQ;EACI,6BAAA;EACA,iBAAA;AAIZ;AAFQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AAIZ;AAFQ;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AAIZ;AAFQ;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAIZ;AAFQ;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAIZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
